import React, { Component } from 'react'
import Form from 'devextreme-react/form'

class InformasiKeluarga extends Component {
    constructor(props) {
        super(props)

        this.class = this.props.actionType === 'add' ? 'bd-input-popup-dapen-default' : 'bd-input-popup-disabled-dapen-default'

        this.state = {
            formData: {}
        }

        this.formRef = React.createRef()

        this.formItems = [
            {
                itemType: 'group',
                cssClass: 'group-form',
                caption: 'Keluarga',
                items: [
                    {
                        itemType: 'group',
                        cssClass: 'group-form',
                        items: [
                            {
                                dataField: 'namaIstriSuami',
                                label: {
                                    text: 'Nama Istri/Suami',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class,
                                    }
                                },
                                validationRules: [
                                    {
                                        type: "required",
                                        message: "Nama Istri/Suami Harus diisi"
                                    }
                                ]
                            },
                            {
                                dataField: 'noKtpIstriSuami',
                                colSpan: 3,
                                label: {
                                    text: 'No KTP Istri/Suami',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class
                                    },
                                    maxLength: 16,
                                },
                                validationRules: [
                                    {
                                        type: "required",
                                        message: "No KTP Istri/Suami Harus diisi"
                                    },
                                    {
                                        type: 'numeric',
                                        message: 'No KTP Istri/Suami Harus Angka'
                                    }
                                ]
                            },
                            {
                                dataField: 'tanggalLahirPasangan',
                                label: {
                                    text: 'Tanggal Lahir Istri/Suami',
                                    alignment: 'left',
                                },
                                editorType: 'dxDateBox',
                                editorOptions: {
                                    placeholder: 'dd MMM yyyy',
                                    displayFormat: 'dd MMM yyyy',
                                    useMaskBehavior: true,
                                    openOnFieldClick: true,
                                    elementAttr: {
                                        class: this.class
                                    }
                                },
                                validationRules: [
                                    {
                                        type: "required",
                                        message: "Tanggal Lahir Istri/Suami Harus diisi"
                                    }
                                ]
                            },
                            {
                                dataField: 'tempatLahirPasangan',
                                colSpan: 3,
                                label: {
                                    text: 'Tempat Lahir Istri/Suami',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class
                                    }
                                },
                                validationRules: [
                                    {
                                        type: "required",
                                        message: "Tempat Lahir Istri/Suami Harus diisi"
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        itemType: 'group',
                        cssClass: 'group-form',
                        items: [
                            {
                                dataField: 'namaAnak1',
                                label: {
                                    text: 'Nama Anak 1',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class,
                                    }
                                },
                                validationRules: [
                                    {
                                        type: "required",
                                        message: "Nama Anak 1 Harus diisi"
                                    }
                                ]
                            },
                            {
                                dataField: 'tanggalLahirAnak1',
                                label: {
                                    text: 'Tanggal Lahir Anak 1',
                                    alignment: 'left',
                                },
                                editorType: 'dxDateBox',
                                editorOptions: {
                                    placeholder: 'dd MMM yyyy',
                                    displayFormat: 'dd MMM yyyy',
                                    useMaskBehavior: true,
                                    openOnFieldClick: true,
                                    elementAttr: {
                                        class: this.class
                                    }
                                },
                                validationRules: [
                                    {
                                        type: "required",
                                        message: "Tanggal Lahir Anak 1 Harus diisi"
                                    }
                                ]
                            },
                            {
                                dataField: 'tempatLahirAnak1',
                                colSpan: 3,
                                label: {
                                    text: 'Tempat Lahir Anak 1',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class
                                    }
                                },
                                validationRules: [
                                    {
                                        type: "required",
                                        message: "Tempat Lahir Anak 1 Harus diisi"
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        itemType: 'group',
                        cssClass: 'group-form',
                        items: [
                            {
                                dataField: 'namaAnak2',
                                label: {
                                    text: 'Nama Anak 2',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class,
                                    }
                                }
                            },
                            {
                                dataField: 'tanggalLahirAnak2',
                                label: {
                                    text: 'Tanggal Lahir Anak 2',
                                    alignment: 'left',
                                },
                                editorType: 'dxDateBox',
                                editorOptions: {
                                    placeholder: 'dd MMM yyyy',
                                    displayFormat: 'dd MMM yyyy',
                                    useMaskBehavior: true,
                                    openOnFieldClick: true,
                                    elementAttr: {
                                        class: this.class
                                    }
                                }
                            },
                            {
                                dataField: 'tempatLahirAnak2',
                                colSpan: 3,
                                label: {
                                    text: 'Tempat Lahir Anak 2',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class
                                    }
                                }
                            },
                        ]
                    },
                    {
                        itemType: 'group',
                        cssClass: 'group-form',
                        items: [
                            {
                                dataField: 'namaAnak3',
                                label: {
                                    text: 'Nama Anak 3',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class,
                                    }
                                }
                            },
                            {
                                dataField: 'tanggalLahirAnak3',
                                label: {
                                    text: 'Tanggal Lahir Anak 3',
                                    alignment: 'left',
                                },
                                editorType: 'dxDateBox',
                                editorOptions: {
                                    placeholder: 'dd MMM yyyy',
                                    displayFormat: 'dd MMM yyyy',
                                    useMaskBehavior: true,
                                    openOnFieldClick: true,
                                    elementAttr: {
                                        class: this.class
                                    }
                                }
                            },
                            {
                                dataField: 'tempatLahirAnak3',
                                colSpan: 3,
                                label: {
                                    text: 'Tempat Lahir Anak 3',
                                    alignment: 'left',
                                },
                                editorOptions: {
                                    elementAttr: {
                                        class: this.class
                                    }
                                }
                            },
                        ]
                    }
                ]
            }
        ]
    }
    
    retrieveData = (data) => {
        this.formRef.current.instance.updateData(data)
    }

    removeState = () => {
        this.setState({
            formData: {}
        })
    }

    validate = () => {
        var validate = this.formRef.current.instance.validate()

        return validate
    }

    sendData = () => {
        let data = this.state.formData

        return data
    }

    render() {
        return (
            <React.Fragment>
                <Form
                    id={'formDataManfaatPensiun'}
                    ref={this.formRef}
                    colCount={1}
                    formData={this.state.formData}
                    items={this.formItems}
                    labelLocation='left'
                    readOnly={this.props.actionType === 'edit' ? true : false}
                />
            </React.Fragment>
        )
    }
}

export default InformasiKeluarga